(function() {
  'use strict';

  angular.module('app.previewpanel')
    .factory('PreviewPanel', PreviewPanel);

  function PreviewPanel(esriRegistry, $q) {
    let PreviewPanelService = {
      queryAttachments: queryAttachments
    };

    return PreviewPanelService;

    //////////// functions

    function queryAttachments(objectid, featureLayer) {
      let d = $q.defer();
      featureLayer.queryAttachmentInfos(objectid, function(results) {
        d.resolve(results);
      });
      return d.promise;
    }
  }
}());
